<template>

    <div id="app">
            <div class="container">
                <b-navbar toggleable="lg" type="light">
                    <b-navbar-brand href="#">
                        <!-- `<router-link>` will be rendered as an `<a>` tag by default -->
                        <router-link to="/home">
                              <img src="./assets/logo.png" 
                                   class="d-inline-block align-top"
                                   style="height: 60px;" />
                              <span class="logo-txt">valledicomino.it</span>
                        </router-link>
                    </b-navbar-brand>

                    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                    <b-collapse id="nav-collapse" is-nav>
                        <!-- Right aligned nav items -->
                        <b-navbar-nav class="ml-auto">
                            <b-nav-item to="/mappa" id="link-mappa">Mappa</b-nav-item>
                            <b-nav-item to="/come-funziona">Come funziona</b-nav-item>
                            <b-nav-item to="/la-valle">La valle</b-nav-item>
                            <b-nav-item to="/domande-frequenti">Domande frequenti</b-nav-item>
                            <b-nav-item to="/azienda">Sono un'azienda</b-nav-item>
                        </b-navbar-nav>
                    </b-collapse>
                </b-navbar>
            </div>
            <!-- component matched by the route will render here -->
            <router-view></router-view>
            <Footer></Footer>
    </div>

</template>

<script>

import Footer from "./components/Footer";

export default {
  name: 'App',
  components: {
    Footer
  },
  created() {
    console.log(process.env.VUE_APP_ENV);
    console.log(process.env.VUE_APP_API_URL);
  }
}

</script>

<style>


</style>
